import Filter from '../filter/filter';

export default new class Sorting {
  constructor() {
    this.activeClass = '_active';

    this.sorting = '.sorting';
    this.sortingItem = '.sorting__item';

    this.bindEvents();
  }

  bindEvents() {
    if (!$('.sorting').length) return;

    $(document).on('click', this.sortingItem, (e) => {
      const $clickedItem = $(e.currentTarget);

      if (!$(e.currentTarget).hasClass(this.activeClass)) {
        const $sortingItemsArr = $clickedItem.closest(this.sorting).find(this.sortingItem);

        Filter.toggleItems($sortingItemsArr, $clickedItem);
      }
    });
  }
}();
